/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GameLogicV4, GameLogicV4Interface } from "../GameLogicV4";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "gladiatorContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "tournamentContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetsContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "equipmentContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tournamentId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "decided",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "winner",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "registrationId",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "attack",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "faction",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "attack",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "defense",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "percentChanceOfUse",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "numberOfUsesPerGame",
                    type: "uint256",
                  },
                  {
                    internalType: "bytes32",
                    name: "createdAt",
                    type: "bytes32",
                  },
                ],
                internalType: "struct IGameEquipment.EquipmentMetadata[]",
                name: "equipment",
                type: "tuple[]",
              },
              {
                internalType: "uint256[]",
                name: "equipmentUses",
                type: "uint256[]",
              },
            ],
            internalType: "struct ITournamentV4.GameGladiator[]",
            name: "players",
            type: "tuple[]",
          },
        ],
        internalType: "struct ITournamentV4.Game",
        name: "game",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
            ],
            internalType: "struct IDiceRolls.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRolls.RollParams[]",
        name: "rolls",
        type: "tuple[]",
      },
    ],
    name: "blowByBlow",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "attackerIsWinner",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "attacker",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "defender",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "attackRoll",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defenseRoll",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "attackFactionBonus",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defenseFactionBonus",
            type: "int256",
          },
          {
            internalType: "uint256[]",
            name: "attackEquipment",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "defenseEquipment",
            type: "uint256[]",
          },
          {
            internalType: "int256",
            name: "attackerHP",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defenderHP",
            type: "int256",
          },
        ],
        internalType: "struct GameLogicV4.Narrative[]",
        name: "narratives",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "specifiedLastRoll",
        type: "int256",
      },
    ],
    name: "bracket",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "tournamentId",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "decided",
                type: "bool",
              },
              {
                internalType: "uint8",
                name: "winner",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "firstRoll",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "lastRoll",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "registrationId",
                    type: "uint256",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "attack",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "defense",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "faction",
                    type: "uint256",
                  },
                  {
                    components: [
                      {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                      },
                      {
                        internalType: "string",
                        name: "name",
                        type: "string",
                      },
                      {
                        internalType: "int256",
                        name: "hitPoints",
                        type: "int256",
                      },
                      {
                        internalType: "int256",
                        name: "attack",
                        type: "int256",
                      },
                      {
                        internalType: "int256",
                        name: "defense",
                        type: "int256",
                      },
                      {
                        internalType: "uint256",
                        name: "percentChanceOfUse",
                        type: "uint256",
                      },
                      {
                        internalType: "uint256",
                        name: "numberOfUsesPerGame",
                        type: "uint256",
                      },
                      {
                        internalType: "bytes32",
                        name: "createdAt",
                        type: "bytes32",
                      },
                    ],
                    internalType: "struct IGameEquipment.EquipmentMetadata[]",
                    name: "equipment",
                    type: "tuple[]",
                  },
                  {
                    internalType: "uint256[]",
                    name: "equipmentUses",
                    type: "uint256[]",
                  },
                ],
                internalType: "struct ITournamentV4.GameGladiator[]",
                name: "players",
                type: "tuple[]",
              },
            ],
            internalType: "struct ITournamentV4.Game[]",
            name: "games",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Round[]",
        name: "rounds",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "equipper",
    outputs: [
      {
        internalType: "contract Equipper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "gameGladiators",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "registrationId",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "hitPoints",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "attack",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "defense",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "faction",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "attack",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "defense",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "percentChanceOfUse",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "numberOfUsesPerGame",
                type: "uint256",
              },
              {
                internalType: "bytes32",
                name: "createdAt",
                type: "bytes32",
              },
            ],
            internalType: "struct IGameEquipment.EquipmentMetadata[]",
            name: "equipment",
            type: "tuple[]",
          },
          {
            internalType: "uint256[]",
            name: "equipmentUses",
            type: "uint256[]",
          },
        ],
        internalType: "struct ITournamentV4.GameGladiator[]",
        name: "gladiators",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tournamentId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "decided",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "winner",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "registrationId",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "attack",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "faction",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "attack",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "defense",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "percentChanceOfUse",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "numberOfUsesPerGame",
                    type: "uint256",
                  },
                  {
                    internalType: "bytes32",
                    name: "createdAt",
                    type: "bytes32",
                  },
                ],
                internalType: "struct IGameEquipment.EquipmentMetadata[]",
                name: "equipment",
                type: "tuple[]",
              },
              {
                internalType: "uint256[]",
                name: "equipmentUses",
                type: "uint256[]",
              },
            ],
            internalType: "struct ITournamentV4.GameGladiator[]",
            name: "players",
            type: "tuple[]",
          },
        ],
        internalType: "struct ITournamentV4.Game",
        name: "game",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
            ],
            internalType: "struct IDiceRolls.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRolls.RollParams",
        name: "roll",
        type: "tuple",
      },
      {
        internalType: "uint256[]",
        name: "factionBonuses",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "lastWinner",
        type: "uint256",
      },
    ],
    name: "getRoll",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "attacker",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "defender",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "attackRoll",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defenseRoll",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "attackHpAddition",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defenseHpAddition",
            type: "int256",
          },
        ],
        internalType: "struct IGameLogicV4.RollReturn",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tournamentId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "decided",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "winner",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "registrationId",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "attack",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "faction",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "attack",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "defense",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "percentChanceOfUse",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "numberOfUsesPerGame",
                    type: "uint256",
                  },
                  {
                    internalType: "bytes32",
                    name: "createdAt",
                    type: "bytes32",
                  },
                ],
                internalType: "struct IGameEquipment.EquipmentMetadata[]",
                name: "equipment",
                type: "tuple[]",
              },
              {
                internalType: "uint256[]",
                name: "equipmentUses",
                type: "uint256[]",
              },
            ],
            internalType: "struct ITournamentV4.GameGladiator[]",
            name: "players",
            type: "tuple[]",
          },
        ],
        internalType: "struct ITournamentV4.Game",
        name: "game",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
            ],
            internalType: "struct IDiceRolls.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRolls.RollParams[]",
        name: "rolls",
        type: "tuple[]",
      },
    ],
    name: "roll",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tournamentId",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "decided",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "winner",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "registrationId",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "attack",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "defense",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "faction",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "attack",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "defense",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "percentChanceOfUse",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "numberOfUsesPerGame",
                    type: "uint256",
                  },
                  {
                    internalType: "bytes32",
                    name: "createdAt",
                    type: "bytes32",
                  },
                ],
                internalType: "struct IGameEquipment.EquipmentMetadata[]",
                name: "equipment",
                type: "tuple[]",
              },
              {
                internalType: "uint256[]",
                name: "equipmentUses",
                type: "uint256[]",
              },
            ],
            internalType: "struct ITournamentV4.GameGladiator[]",
            name: "players",
            type: "tuple[]",
          },
        ],
        internalType: "struct ITournamentV4.Game",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "registrationId",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "hitPoints",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "attack",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "defense",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "faction",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "int256",
                name: "hitPoints",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "attack",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "defense",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "percentChanceOfUse",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "numberOfUsesPerGame",
                type: "uint256",
              },
              {
                internalType: "bytes32",
                name: "createdAt",
                type: "bytes32",
              },
            ],
            internalType: "struct IGameEquipment.EquipmentMetadata[]",
            name: "equipment",
            type: "tuple[]",
          },
          {
            internalType: "uint256[]",
            name: "equipmentUses",
            type: "uint256[]",
          },
        ],
        internalType: "struct ITournamentV4.GameGladiator[]",
        name: "gladiators",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
            ],
            internalType: "struct IDiceRolls.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRolls.RollParams[]",
        name: "rolls",
        type: "tuple[]",
      },
    ],
    name: "tournament",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "tournamentId",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "decided",
                type: "bool",
              },
              {
                internalType: "uint8",
                name: "winner",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "firstRoll",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "lastRoll",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "id",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "registrationId",
                    type: "uint256",
                  },
                  {
                    internalType: "int256",
                    name: "hitPoints",
                    type: "int256",
                  },
                  {
                    internalType: "uint256",
                    name: "attack",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "defense",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "faction",
                    type: "uint256",
                  },
                  {
                    components: [
                      {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                      },
                      {
                        internalType: "string",
                        name: "name",
                        type: "string",
                      },
                      {
                        internalType: "int256",
                        name: "hitPoints",
                        type: "int256",
                      },
                      {
                        internalType: "int256",
                        name: "attack",
                        type: "int256",
                      },
                      {
                        internalType: "int256",
                        name: "defense",
                        type: "int256",
                      },
                      {
                        internalType: "uint256",
                        name: "percentChanceOfUse",
                        type: "uint256",
                      },
                      {
                        internalType: "uint256",
                        name: "numberOfUsesPerGame",
                        type: "uint256",
                      },
                      {
                        internalType: "bytes32",
                        name: "createdAt",
                        type: "bytes32",
                      },
                    ],
                    internalType: "struct IGameEquipment.EquipmentMetadata[]",
                    name: "equipment",
                    type: "tuple[]",
                  },
                  {
                    internalType: "uint256[]",
                    name: "equipmentUses",
                    type: "uint256[]",
                  },
                ],
                internalType: "struct ITournamentV4.GameGladiator[]",
                name: "players",
                type: "tuple[]",
              },
            ],
            internalType: "struct ITournamentV4.Game[]",
            name: "games",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "firstRoll",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastRoll",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Round[]",
        name: "rounds",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "tournamentWinner",
    outputs: [
      {
        internalType: "uint256",
        name: "registrationId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastRoll",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class GameLogicV4__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    gladiatorContract: string,
    tournamentContract: string,
    assetsContract: string,
    equipmentContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GameLogicV4> {
    return super.deploy(
      gladiatorContract,
      tournamentContract,
      assetsContract,
      equipmentContract,
      overrides || {}
    ) as Promise<GameLogicV4>;
  }
  getDeployTransaction(
    gladiatorContract: string,
    tournamentContract: string,
    assetsContract: string,
    equipmentContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      gladiatorContract,
      tournamentContract,
      assetsContract,
      equipmentContract,
      overrides || {}
    );
  }
  attach(address: string): GameLogicV4 {
    return super.attach(address) as GameLogicV4;
  }
  connect(signer: Signer): GameLogicV4__factory {
    return super.connect(signer) as GameLogicV4__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GameLogicV4Interface {
    return new utils.Interface(_abi) as GameLogicV4Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GameLogicV4 {
    return new Contract(address, _abi, signerOrProvider) as GameLogicV4;
  }
}
